export default __webpack_public_path__ + "static/media/beach.67b3ac7b.png";